// Injects the Tauri hotkey registration into @heidi/dictate's hotkey-ports
// seam (SCR-7069). Imported for effect in `_app.tsx`. Static import is safe:
// the runtime cone of `@/tauri/dictation/api` never reaches the store.
import { setDictationHotkey } from '@/tauri/dictation/api';
import { configureDictationHotkeyPorts } from '@heidi/dictate';

configureDictationHotkeyPorts({ setDictationHotkey });
